import React from 'react'
import NabigationComponent from './NabigationComponent'

const HeaderComponents = () => {
  return (
    <div>
      <NabigationComponent/>
    </div>
  )
}

export default HeaderComponents